/**
 * Labstep
 *
 * @module components/Tag/Form/Edit
 * @desc Editable expeirment table - Auto save on change
 */

import { fieldTagName } from 'labstep-web/components/Tag/Form/fields';
import { EditFormUpdateContainer as EditForm } from 'labstep-web/core/Form/Edit';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import type { ITagFormEditProps } from './types';

export const TagFormEdit: React.FC<ITagFormEditProps> = ({
  tag,
  options,
}) => (
  <EditForm
    autoFocus
    entityName={Tag.entityName}
    entity={tag}
    fields={[fieldTagName]}
    options={options}
  />
);
